import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { mailPreferencesAPI } from '../api/mail-preferences';

export function useMailPreferences() {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['mail-preferences'],
    queryFn: () => mailPreferencesAPI.getPreferences(),
  });

  const updateMutation = useMutation({
    mutationFn: (settings) => mailPreferencesAPI.updatePreferences(settings),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['mail-preferences'] }),
  });

  const disableMutation = useMutation({
    mutationFn: () => mailPreferencesAPI.disableSubscription(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['mail-preferences'] }),
  });

  return {
    preferences: query.data?.subscription,
    isLoading: query.isLoading,
    isUpdating: updateMutation.isPending || disableMutation.isPending,
    update: updateMutation.mutate,
    disable: disableMutation.mutate,
    error: query.error || updateMutation.error,
  };
}
